import { render, staticRenderFns } from "./OrdersView.vue?vue&type=template&id=34dfedb5&scoped=true"
import script from "./OrdersView.vue?vue&type=script&lang=ts"
export * from "./OrdersView.vue?vue&type=script&lang=ts"
import style0 from "./OrdersView.vue?vue&type=style&index=0&id=34dfedb5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34dfedb5",
  null
  
)

export default component.exports